import { render, staticRenderFns } from "./_photoId.vue?vue&type=template&id=072f9521&scoped=true"
import script from "./_photoId.vue?vue&type=script&lang=ts"
export * from "./_photoId.vue?vue&type=script&lang=ts"
import style0 from "./_photoId.vue?vue&type=style&index=0&id=072f9521&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072f9521",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VideoPlayer: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/VideoPlayer/index.vue').default})
